import React, { useState, useEffect } from 'react';
import { Product } from '../types';
import { getLowStockProducts } from '../utils/storage';
import SvgIcon from '../utils/svgIcons';

interface NotificationsProps {
  onViewProduct: (product: Product) => void;
  lowStockProducts?: Product[];
}

const Notifications: React.FC<NotificationsProps> = ({ onViewProduct, lowStockProducts: externalLowStockProducts }) => {
  const [lowStockProducts, setLowStockProducts] = useState<Product[]>([]);

  useEffect(() => {
    if (externalLowStockProducts) {
      setLowStockProducts(externalLowStockProducts);
    } else {
      checkLowStockProducts();
      
      // Check for low stock products every 30 seconds
      const interval = setInterval(checkLowStockProducts, 30000);
      
      return () => clearInterval(interval);
    }
  }, [externalLowStockProducts]);

  const checkLowStockProducts = () => {
    const products = getLowStockProducts();
    setLowStockProducts(products);
  };

  return (
    <div className="app-container notifications-page">
      <h2>Notifications</h2>
      {lowStockProducts.length === 0 ? (
        <div className="no-notifications-page">
          No low stock notifications
        </div>
      ) : (
        <div className="notifications-list-page">
          {lowStockProducts.map(product => (
            <div 
              key={product.id} 
              className="notification-item-page"
              onClick={() => onViewProduct(product)}
            >
              <div className="notification-content-page">
                <SvgIcon name="warning" color="#f39c12" size={28} className="notification-icon-page" />
                <div className="notification-text-page">
                  <h3>{product.name}</h3>
                  <p>Low stock: <strong>{product.quantity} pcs</strong></p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Notifications; 